import { Type } from 'class-transformer';
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { DpeState } from './property-enums';

export class PropertyDpeTechnicalDto {
  @IsOptional()
  @IsNumber()
  ceilingHeight?: number;

  @IsOptional()
  @IsString()
  heatingType?: string;

  @IsOptional()
  @IsString()
  heatingEnergy?: string;

  @IsOptional()
  @IsString()
  heatingGenerator?: string;

  @IsOptional()
  @IsString()
  heatingEmitter?: string;

  @IsOptional()
  @IsBoolean()
  hasAirConditioning?: boolean;

  @IsOptional()
  @IsString()
  ventilationType?: string;

  @IsOptional()
  @IsString()
  constructionPeriod?: string;

  @IsOptional()
  @IsString()
  wallInsulation?: string;

  @IsOptional()
  @IsString()
  roofInsulation?: string;

  @IsOptional()
  @IsString()
  glazingQuality?: string;

  @IsOptional()
  @IsString()
  floorInsulation?: string;

  @IsOptional()
  @IsString()
  envelopeQuality?: string;
}

export class PropertyDpeDto {
  @IsEnum(DpeState)
  state!: DpeState;

  @IsOptional()
  @IsString()
  type?: string;

  @IsOptional()
  @IsString()
  version?: string;

  @IsOptional()
  @IsNumber()
  energyConsumption?: number; // kWh/m2.an

  @IsOptional()
  @IsNumber()
  greenhouseGasEmission?: number; // kg CO2/m2.an

  @IsOptional()
  @IsString()
  energyClass?: string;

  @IsOptional()
  @IsString()
  climateClass?: string;

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  realizationDate?: Date;

  @IsOptional()
  @IsNumber()
  estimatedCostMin?: number;

  @IsOptional()
  @IsNumber()
  estimatedCostMax?: number;

  @IsOptional()
  @IsNumber()
  finalEnergyConsumption?: number; // kWh/m2.an

  @IsOptional()
  @IsDate()
  @Type(() => Date)
  priceIndexingDate?: Date;

  @IsOptional()
  @IsString()
  ademeNumber?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyDpeTechnicalDto)
  technical?: PropertyDpeTechnicalDto;

  @IsOptional()
  metadata?: Record<string, unknown>;
}
